import {
	CategoryKeys,
	type GetQuestionResponse,
	type QuestionIDType,
} from 'help/types/types'
import type { UserLoyalty } from 'types/session/user'

export const getFilteredQuestions = ({
	allQuestions,
	questionsIds,
	isLoyalty,
}: {
	allQuestions: (GetQuestionResponse | null)[]
	questionsIds: QuestionIDType[]
	isLoyalty: UserLoyalty | undefined
}) => {
	return allQuestions.filter(
		(question) =>
			questionsIds.find(
				(questionId) =>
					questionId.categoryKey === question?.question.categoryKey &&
					questionId.questionKey === question?.question.key
			) &&
			!(question?.question.categoryKey === CategoryKeys.loyalty && !isLoyalty)
	)
}
